const Help = () => {
  return (
    <section className="helpContainer">
      <h2>Wondering where to start?</h2>
      <ul>
        <li> Pick a color or click random color to style based on your Mood.</li>
        <li> Type in your thoughts and click the button to share them with the World.</li>
        <li> Click the delete button to delete your thoughts Forever.</li>
        <li> Click the star button to Favorite.</li>
        <li> Checkout thoughts from each thinker by clicking on their UserID.</li>
      </ul>
    </section>
  );
}

export default Help;